<template>
  <div ref="turnstileBox" id="turnstile-box"></div>
</template>

<script>
import { turnstileResetTimeout, turnstileURL } from "../../../turnstile.config";

export default {
  name: "TurnstileComponent",
  props: {
    // Prop for the Turnstile site key
    sitekey: {
      type: String,
      required: true,
    },
    // Prop for the Turnstile theme: light, dark, auto
    theme: {
      type: String,
      required: false,
      default: "light",
    },
    // Prop for the Turnstile size: normal, compact
    size: {
      type: String,
      required: false,
      default: "normal",
    },
    // Prop for the Turnstile language ; default "en"
    language: {
      type: String,
      required: false,
      default: "en",
    },
  },
  data() {
    return {
      resetTimeout: null, // Timeout for Turnstile reset
    };
  },
  mounted() {
    this.loadTurnstileScript();
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    /**
     * Loads the Turnstile script if not already loaded.
     * Otherwise, renders the Turnstile component.
     */
    loadTurnstileScript() {
      if (!window.turnstile) {
        const script = document.createElement("script");
        script.src = turnstileURL;
        script.async = true;
        document.head.appendChild(script);
      } else {
        this.renderTurnstile();
      }

      window.onloadTurnstileCallback = this.renderTurnstile;
    },
    /**
     * Renders the Turnstile component with the specified props.
     */
    renderTurnstile() {
      if (window.turnstile) {
        window.turnstile.render(this.$refs.turnstileBox, {
          sitekey: this.sitekey,
          theme: this.theme,
          size: this.size,
          language: this.language,
          callback: this.onVerify,
          "expired-callback": this.onExpire,
          "error-callback": this.onError,
        });
      }
    },
    /**
     * Called upon Turnstile verification.
     * @param {string} response - Verification response.
     */
    onVerify(response) {
      this.$emit("verify", response);
      this.startResetTimeout();
    },
    /**
     * Called when Turnstile expires.
     */
    onExpire() {
      this.$emit("expire");
    },
    /**
     * Called in case of a Turnstile error.
     */
    onError() {
      this.$emit("fail");
    },
    /**
     * Cleans up resources utilized by Turnstile.
     */
    cleanup() {
      if (window.turnstile) {
        window.turnstile.remove();
      }
      clearTimeout(this.resetTimeout);
      delete window.onloadTurnstileCallback;
    },
    /**
     * Begins the countdown to reset Turnstile.
     */
    startResetTimeout() {
      this.resetTimeout = setTimeout(() => {
        this.cleanup();
        this.renderTurnstile();
        // Resets Turnstile after turnstileResetTimeout seconds
      }, turnstileResetTimeout * 1000);
    },
    reset() {
      this.cleanup();
      this.renderTurnstile();
    },
  },
};
</script>
